import React from "react"
import { useDispatch } from "react-redux"
import { useTranslation } from "react-i18next"
import { styled, Theme } from "@mui/material/styles"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import { FormControlLabel, RadioGroup } from "@mui/material"
import { Ipg } from "types/order.types"
import { useAppSelector } from "appRedux/hooks"
import { updateSelectedIpgId } from "appRedux/slices/orderSlice"
import RadioButton from "components/atoms/RadioButton"

type IpgListProps = {
  ipgList: Ipg[];
  onChange: (selectedId: number) => void;
}

export default function IpgSection(props: IpgListProps) {
  const { ipgList, onChange } = props

  const selectedIpgId = useAppSelector((state) => state.order.selectedIpgId)

  const { t } = useTranslation()
  const dispatch = useDispatch()

  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const newSelectedId = Number(event.target.value)
    dispatch(updateSelectedIpgId(newSelectedId))
    if (!onChange) return
    onChange(newSelectedId)
  }

  return (
    <div>
      <Title>{t("checkout.onlinePaymentGateway")}</Title>
      <StyledRadioGroup
        defaultValue={ipgList[0].id}
        aria-labelledby="ipg-radios"
        name="ipg-radio-list"
        onChange={handleChange}
      >
        {ipgList.map(ipg => (
          <IpgCard
            key={ipg.id}
            control={<RadioButton/>}
            value={ipg.id}
            label={<Stack direction="row" gap="16px" alignItems="center">
              <img src={`/static/images/ipg/${ipg.slug}.png`} alt=""/>
              <IpgName>{ipg.name}</IpgName>
            </Stack>}
            ischecked={selectedIpgId === ipg.id ? 1 : 0}
          />
        ))}
      </StyledRadioGroup>
    </div>
  )
}

const Title = styled(Typography)(({ theme }) => ({
  fontSize: "1.5rem",
  fontWeight: 700,
  color: theme.palette.gray["14"],
  marginTop: "8px",
  marginBottom: "12px"
}))

const StyledRadioGroup = styled(RadioGroup)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px"
}))

type IpgCardProps = {
  theme?: Theme;
  ischecked: 1 | 0;
}

const IpgCard = styled(FormControlLabel)(({ theme, ischecked }: IpgCardProps) => ({
  width: "100%",
  flexDirection: "row-reverse",
  justifyContent: "space-between",
  margin: 0,
  padding: "6px 16px 6px 10px",
  borderRadius: "8px",
  border: `1px solid ${ischecked ? theme?.palette.success["2"] : "transparent"}`,
  boxShadow: `0 0 7px 0 ${theme?.palette.gray["6"]}`,
  transition: "0.3s",

  "& .MuiButtonBase-root": {
    width: "24px",
    height: "24px"
  },

  "& img": {
    width: "60px"
  }
}))

const IpgName = styled("span")(({ theme }) => ({
  fontSize: "1.5rem",
  color: theme?.palette.gray["15"]
}))

